import AdjustInfographicComponent from '../components/infographic/adjust-infographic/adjust-infographic.component';
import { useParams } from "react-router-dom";

const AdjustInfographic = () => {
    const { mediaId, infoId } = useParams();

    return (
        <AdjustInfographicComponent mediaId={mediaId} infoId={infoId} />
    )

}

export default AdjustInfographic;